import React from 'react';
import DestinationLogo from './DestinationLogo';
import './Header.css';

function Header({ isAdmin, user, onLogout }) {
  return (
    <header className={isAdmin ? 'admin-header' : ''}>
      {isAdmin ? (
        <div className="admin-header-content">
          <div className="admin-title">
            <DestinationLogo height={40} />
            <p className="tagline">VMHS · CTE Senior Awards · Admin Dashboard</p>
          </div>

          {user && (
            <div className="admin-user-info">
              <span className="user-email">{user.email}</span>
              <button onClick={onLogout} className="logout-button">
                Logout
              </button>
            </div>
          )}
        </div>
      ) : (
        <div className="admin-header-content">
          <div className="admin-title">
            <DestinationLogo height={40} />
            <p className="tagline">Veterans Memorial High School · CTE Senior Awards</p>
          </div>
        </div>
      )}
    </header>
  );
}

export default Header;
